import { EventBus } from '@johnlewispartnership/wtr-website-eventbus';

export const SLOTS_EVENTS_CHANNEL = 'wtr-events.slots';
export const SLOT_RESERVATION_FOR_ORDER_CHANGED_EVENT = 'slot_reservation_for_order_changed';

const SlotsEventBus = new EventBus(SLOTS_EVENTS_CHANNEL);
export default SlotsEventBus;
